<template>
  <div>
    <div class="wrap coaching-finish-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>예약된 코칭</h3>
      </div>
      <div class="body-wrap">
        <div class="time">
          <img src="@/assets/img/time-icon-b.svg" alt="시간 아이콘" />
          <p>{{ course.startDate }}({{ course.day }}) {{ course.startTime }}~{{ course.endTime }} ({{ course.time }}분)</p>
        </div>
        <div class="coach">
          <div class="w-100per clear">
            <div class="w-50per float-left txt-left">
              <p class="company">{{ course.companyName }}</p>
            </div>
            <div class="w-50per float-left txt-right" @click="viewSurvey(course.userIdx)">
              <span class="survey">서베이 보기</span>
            </div>
          </div>
          <div class="info">
            <h3>
              {{ course.userName }}
              <!-- <span>{{ course.userGrade }}</span> -->
            </h3>
            <h4>{{ course.sessionType }}코칭 <span></span>{{ course.currentSession }}회기</h4>
          </div>
          <div class="contact">
            <ul>
              <li>
                <img src="@/assets/img/phone-call.svg" @click="sendCall()" v-if="isCall" class="call-img" />
                <img src="@/assets/img/mic.svg" @click="sendWebex()" v-if="isWebex" class="mic-img" />
                <img src="@/assets/img/talk-message.svg" alt="대화아이콘" @click="viewMessage()" />
              </li>
            </ul>
          </div>
        </div>
        <div class="coach-goal">
          <ul>
            <li>
              <h3>관심 코칭 주제</h3>
              <p class="preline">
                <font v-for="(item, index) in embedded" :key="index" :class="{ active: index == 0 }"> {{ index + 1 }}. {{ item.parentSubject }} - {{ item.subject }}<br /> </font>
              </p>
            </li>
            <li>
              <h3>코칭 목표</h3>
              <p class="preline">{{ course.coarchingSubject }}</p>
            </li>
            <li>
              <h3>기타의견</h3>
              <p class="preline">{{ course.coarchingEtc }}</p>
            </li>
          </ul>

          <!-- 성찰노트 -->
          <!-- <ul>
                        <li>
                            <h3>코칭 후 새롭게 알게 된 점</h3>
                            <p class="preline">코칭 이전의 모습과 많이 달라진 것을 많이 느낍니다. 
                                구성원들에 대한 생각을 다시 하게 된 것 같고, 현재의 위치에서 성과도 놓치지 않는 방법을 배운 시간이었습니다.
                            </p>
                        </li>
                        <li>
                            <h3>코칭 과제 및 실행 계획</h3>
                            <p class="preline">구성원을 조금 더 세심하게 챙기며 그들이 성장하는 모습을 기대하며, 
                            </p>
                        </li>
                        <li>
                            <h3>코칭 후 기대 하는 점</h3>
                            <p class="preline">구성원을 조금 더 세심하게 챙기며 그들이 성장하는 모습을 기대하며, 
                            </p>
                        </li>
                    </ul> -->
        </div>
        <div class="w-90per mg-auto clear">
          <div class="cancel-btn w-50per float-left">
            <span @click="cacnel()">취소하기</span>
          </div>
          <div class="modify-btn w-50per float-left" @click="scheduleChange()">
            <span>수정하기</span>
          </div>
        </div>
        <div class="coaching-btn" v-if="this.$store.state.isCoarchingTime">
          <button @click="journalWrite()" v-if="course.coarchingYN == 'N'">코칭일지 작성하기</button>
          <button class="re-reserve" @click="userCancel()">고객 당일 취소</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import dayjs from "dayjs";
export default {
  name: "reservation_coahcing_view",
  props: {
    sessionIdx: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    course: {},
    embedded: [],
    isWebex: false,
    isCall: false,
  }),
  components: {
    incBack,
  },
  mounted() {
    this.getCoarchingDetail();
  },
  methods: {
    getCoarchingDetail() {
      let params = {
        sessionIdx: this.sessionIdx,
      };
      this.axios
        .get("/front/coarching/reservation/detail", { params })
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            this.course = res.data.contentinfo.coarchReservationList;
            if (this.course.sessionType.includes("화상")) {
              this.isWebex = true;
            } else {
              this.isWebex = false;
            }
            if (this.course.sessionType.includes("전화")) {
              this.isCall = true;
            } else {
              this.isCall = false;
            }
            this.course.startDate = dayjs(this.course.startDate).format("YYYY-MM-DD HH:mm:ss").replace(/-/g, "/");
            this.$store.commit("setCoachingDays", dayjs(this.course.startDate).day());
            this.course.day = this.$store.state.coachingDays;

            this.course.startTime = dayjs(this.course.startDate).format("HH:mm");
            this.course.endTime = dayjs(this.course.endDate).format("HH:mm");

            let timeValue = {
              startTime: this.course.startTime,
              endTime: this.course.endTime,
            };
            this.$store.commit("setCoachingTime", timeValue);
            this.course.time = this.$store.state.coachingTime;

            this.$store.commit("setIsCoarchingTime", this.course.startDate);

            this.course.startDate = dayjs(this.course.startDate).format("YYYY.MM.DD");

            let temp = this.course.sessionPer.split("/");
            this.course.currentSession = temp[0];

            this.embedded = res.data.contentinfo.userEmbeddedSurvey;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cacnel() {
      if (confirm("해당 코칭을 취소 하시겠습니까? ")) {
        // console.log("success");
        let form = new FormData();
        form.append("sessionIdx", this.sessionIdx);
        form.append("courseIdx", this.course.courseIdx);
        this.axios
          .post("/front/coarch/reserved/cancel", form)
          .then((res) => {
            // console.log(res);
            if (res.data.success) {
              alert("코칭이 취소되었습니다.");
              this.$router.go(-1);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    sendCall() {
      if (confirm("고객에게 전화를 걸겠습니까?")) {
        location.href = "tel:" + this.course.userHandphone;
      }
    },
    sendWebex() {
      if (confirm("고객에게 화상미팅 URL을 전달 하시겠습니까? ")) {
        let params = {
          userIdx: 0,
          coachIdx: 0,
          origin: "COACH",
          chatContent: "",
        };
        params.userIdx = this.course.userIdx;
        params.coachIdx = this.$store.state.userInfo.idxTbCoarch;
        params.chatContent = `안녕하세요 ${this.course.userName} 고객님<br>화상 미팅 URL 전달드립니다.<br>URL : <a href="${this.course.coarchingWebxUrl}" target="_blank">${this.course.coarchingWebxUrl}</a>`;
        this.axios
          .post("/chat/send", params)
          .then((res) => {
            // console.log(res);
            if (res.data.success) {
              alert("화상 미팅 URL을 전달하였습니다.");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    viewMessage() {
      this.$router.push({ name: "message", params: { userIdx: this.course.userIdx } });
    },
    viewSurvey(userIdx) {
      // this.$router.push("embedded_survey_report");
      this.$router.push({ name: "embedded_survey_report", params: { userIdx: Number(userIdx), sessionIdx: Number(this.sessionIdx) } });
    },
    scheduleChange() {
      this.$router.push({ name: "schedule_change", params: { sessionIdx: this.sessionIdx } });
    },
    journalWrite() {
      this.$router.push({ name: "coaching_journal_write", params: { sessionIdx: Number(this.sessionIdx), courseIdx: Number(this.course.courseIdx) } });
    },
    userCancel() {
      if (confirm("고객 노쇼 처리 하시겠습니까? 처리 시 복구가 불가능 합니다.")) {
        // let parmas = {
        //     sessionIdx : this.sessionIdx
        // }
        let form = new FormData();
        form.append("sessionIdx", this.sessionIdx);

        this.axios
          .post("/front/coarch/noshow", form)
          .then((res) => {
            if (res.data.success) {
              this.$router.replace({ name: "my_coaching" });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>
